import { FETCH_TEMPLATES } from "../actions/types";

export const templatesReducer = (state = {}, action) => {
  switch (action.type) {
    case FETCH_TEMPLATES:
      return action.payload;
    default:
      return state;
  }
};
